export var EVENTS_KEY = '___settingsEvent';
export function createEventHandler(initialData) {
    if (initialData === void 0) { initialData = {}; }
    var callbacks = {};
    var reset;
    var prevEventData = initialData[EVENTS_KEY];
    return {
        notify: function (data) {
            if (data === void 0) { data = {}; }
            var eventData = data[EVENTS_KEY];
            if (!eventData ||
                (prevEventData &&
                    eventData.payload &&
                    eventData.payload.id === prevEventData.payload.id)) {
                return;
            }
            prevEventData = eventData;
            if (eventData && eventData.event) {
                switch (eventData.event) {
                    case 'reset': {
                        if (reset) {
                            reset();
                        }
                        break;
                    }
                    default: {
                        if (callbacks[eventData.event]) {
                            callbacks[eventData.event](eventData.payload.value);
                        }
                    }
                }
            }
        },
        on: function (event, cb) {
            callbacks[event] = cb;
        },
        onReset: function (cb) {
            reset = cb;
        },
    };
}
//# sourceMappingURL=events.js.map